<template>
  <form-wizard
      ref="refFormWizard"
      :color="color"
      :title="null"
      :subtitle="null"
      finish-button-text="Enregistrer"
      back-button-text="Précédent"
      hide-buttons
      class="checkout-form-wizard steps-transparent"
      @on-complete="onSubmit"
  >
    <!-- product tab -->
    <tab-content
        title="Produits"
        icon="feather icon-list"
    >
      <div class="text-center" v-if="isLoading">
      <b-spinner />
      </div>
      <stock-view-release-product-step-cart v-else @next-step="formWizardNextStep"/>
    </tab-content>

    <!-- information tab -->
    <tab-content
        title="Renseignements"
        icon="feather icon-user-check"
    >
      <stock-view-release-product-step-address
          :details.sync="checkoutDetails"
          @next-step="formWizardNextStep"
      />
    </tab-content>

    <!-- checkout tab -->
    <tab-content
        title="Valider"
        icon="feather icon-check-circle"
    >
      <stock-view-release-product-step-recap
          :details="checkoutDetails"
          @next-step="formWizardNextStep"
      />
    </tab-content>
  </form-wizard>
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import StockViewReleaseProductStepRecap from '@/views/apps/stock-store/stock-store-details/stocks/release/StockViewReleaseProductStepRecap.vue'
import StockViewReleaseProductStepCart from '@/views/apps/stock-store/stock-store-details/stocks/release/StockViewReleaseProductStepCart.vue'
import StockViewReleaseProductStepAddress from '@/views/apps/stock-store/stock-store-details/stocks/release/StockViewReleaseProductStepAddress.vue'
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {useToast} from "vue-toastification/composition";
import router from "@/router";
import {BSpinner} from "bootstrap-vue";

export default {
  components: {
    BSpinner,
    // 3rd Party
    FormWizard,
    TabContent,

    StockViewReleaseProductStepCart,
    StockViewReleaseProductStepAddress,
    StockViewReleaseProductStepRecap,
  },
  setup() {
    const refFormWizard = ref(null);
    const color = ref("#2567d1");
    const toast = useToast();
    const isLoading = ref(false);
    const formWizardNextStep = () => {
      refFormWizard.value.nextTab()
    }
    const showToast = (title, icon, variant) => {
      toast({
        component: ToastificationContent,
        props: {
          title: title,
          icon: icon,
          variant: variant,
        },
      });
    };

    const checkoutDetails = ref({
      concerned_project: null,
      dispatch_date: null,
      return_date: null,
      note: '',
    });

    const fetchReleaseProducts = async () => {
      try {
        isLoading.value = true;
        await store.dispatch("stock/getReleaseProducts", {storeId: router.currentRoute.params.id})
      } catch (e) {
        showToast("Une erreur est survenue lors de la récupération des produits en attente de sortie.", "AlertCircleIcon", "danger");
      } finally {
        isLoading.value = false;
      }
    }

    onMounted(() => fetchReleaseProducts())
    const onSubmit = async () => {
      isLoading.value = true;
      try {
        const releaseProducts = store.getters["stock/release_products"];
        if (releaseProducts.length <= 0) {
          showToast("Aucun produit n'a été ajouté en sortie.", "AlertCircleIcon", "danger");
          return;
        }

        // Map release products data
        const releaseProductsMapped = releaseProducts.map(({uid, qty}) => {
          return {
            uid: uid,
            qty: qty,
          };
        });

        // Prepare request data
        const requestData = {
          ...checkoutDetails.value,
          release_products: releaseProductsMapped,
        };
        await store.dispatch("stock/saveProductsRelease", requestData);
        if (store.getters["stock/errors"] != null) {

          showToast(store.getters["stock/errors"].message, "AlertCircleIcon", "danger");
          return;
        }
        showToast("La sortie a été effectuée avec succès.", "CheckCircleIcon", "success");
        await router.push({name: 'apps-stock-store-details', params: {id: router.currentRoute.params.id}});

      } catch (e) {
        showToast("Une erreur est survenue lors de la sortie.", "AlertCircleIcon", "danger");
      } finally {
        isLoading.value = false;
      }
    };

    return {
      color,
      isLoading,
      refFormWizard,
      formWizardNextStep,

      onSubmit,
      checkoutDetails,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '~@core/scss/base/pages/app-ecommerce.scss';
@import '~vue-form-wizard/dist/vue-form-wizard.min.css';
</style>

<style lang="scss" scoped>
.checkout-form-wizard ::v-deep {
  .wizard-tab-content {
    box-shadow: none !important;
    background: transparent !important;
    padding: 0;
  }
}
</style>
